import { ChangePasswordComponent } from './changePassword.component';
import { UserEditionComponent } from './user.edition.component';
import { IFilterDTO, TaskDTO } from '../../api/plyca-dtos';
import { UserService } from '../../user.service';
import { BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, AfterContentInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { I18nData, UserDTO } from '../../api/plyca-dtos';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { FilteredBaseFormComponent, TModel } from '../../tasks/baseFormComponent/filteredBaseForm.component';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { PropertyService } from '../../properties/property.service';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { PaginationDTO } from '../../api/PaginationModel';
import { AuthService } from '../../auth.service';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../conf/app.constants';
import { tasksListComponent } from '../../tasks/tasksList.component';


@Component({
  selector: 'userpanel-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html',
  providers: [DialogService]
})
export class UsersPanelComponent
  extends FilteredBaseFormComponent<UserDTO>
  implements OnInit, AfterContentInit, OnDestroy {


  private properties = {};
  @ViewChild('actionsTemplate')
  fromTemplate: TemplateRef<any>;

  getObjectIdentifier() {
    throw new Error('Method not implemented.');
  }

  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    private userService: UserService,
    private plycaErrorHandler: PlycaErrorHandler,
    private propertyService: PropertyService,
    public helpService: HelpService,
    private _authService: AuthService,
    private _http: HttpClient,
    private _configuration: Configuration,
    @Optional() protected activatedRoute: ActivatedRoute

  ) {
    super(elem);
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.USERS));

  }
  ngOnInit(): void {

    this.subscribe(
      forkJoin([
        this._authService.isPasswordModifiable()
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          })),
        this.propertyService.getProperty('MNTO_USUARIOS', 'false')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
      ]).pipe(
        map(
          (prop: any[]) => {
            this.properties['isPasswordModifiable'] = (prop[0] === true);
            this.properties['MNTO_USUARIOS'] = prop[1] === 'true';

          }),
        finalize(() => {
          this.autosearch = true;
          super.ngOnInit();
        })
      )
    )
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  ngAfterContentInit(): void {

  }
  getFormSettingURL(): string {
    return 'admin/usersFilterISettings.json';
  }
  getServiceURL(operation?: string): string {
    if (operation === 'insert') {
      return this.configuration.ADMIN_USER_SERVICE_URL;
    } else {
      return this.configuration.USER_SERVICE_URL;
    }

  }
  getTitle(model: UserDTO): string {
    return 'Inboxs.edit.tooltip';
  }
  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'ControlPanel.users.title';
    headerInfo.titleIcon = 'fas fa-user';
    return headerInfo;
  }
  initHeaderActions() {

    this.subscribe(
      this.headerActionsService.addAction(
        'General.reset.filters',
        'fas fa-undo',
        'btn-secondary',
        true
      ), success => {
        this.clearFilter();
        this.model.filter['organizationalUnit'] = this.userService.sessionInfo.user.organizationalUnit;
      });
    this.subscribe(this.headerActionsService
      .addAction(
        'General.search.text',
        'fas fa-search',
        'btn-primary',
        true
      ), () => {

        if (JSON.stringify(this.model.filter) === '{}') {

          this.uiService.showMessage(
            new I18nData('ControlPanel.inboxs.msg.filters'),
            new I18nData('General.info')
          );

        } else {
          this.search();
        }

      });

    this.headerActionsService.addDivider();
    this.addBackAction();
  }
  searchFunction() {


    if (JSON.stringify(this.model.filter) === '{}') {

      this.uiService.showMessage(
        new I18nData('ControlPanel.inboxs.msg.filters'),
        new I18nData('General.info')
      );

    } else {
      this.search();
    }
  }

  initModel(): TModel<UserDTO> {
    this.model = {} as TModel<UserDTO>;
    this.model.ui = {};
    this.model.ui.mensaje = '';
    this.model.ui.showResults = false;
    this.model.filter = {};
    this.model.filter['organizationalUnit'] = this.userService.sessionInfo.user.organizationalUnit;
    this.model.ui.properties = this.properties;
    return this.model;
  }
  updateTableModel(result: PaginationDTO<UserDTO>): TModel<UserDTO> {
    if (result?.content) {
      let content: UserDTO[] = result.content;
      this.model.tableModel = content;
      this.model.ui.mensaje = this.translationService.instant('General.total')
        + ' ' + content.length + ' ' + this.translationService.instant('ControlPanel.users.title');

    } else {
      this.model.ui.mensaje = this.translationService.instant('General.total')
        + ' ' + 0 + ' ' + this.translationService.instant('ControlPanel.users.title');
    }


    this.model.ui.showResults = true;
    return this.model;
  }

  dtoToModel(dto: UserDTO): Observable<TModel<UserDTO>> {
    throw new Error('Method not implemented.');
  }
  modelToDTO(model: TModel<UserDTO>): UserDTO {
    throw new Error('Method not implemented.');
  }
  filterToParam(): IFilterDTO {


    let params = [];
    if (this.model.filter['organizationalUnit'] && this.model.filter['organizationalUnit'].identifier) {
      delete params['organizationalUnitId'];

      params['organizationalUnitId'] = this.model.filter['organizationalUnit'].identifier;

    } else {
      delete params['organizationalUnitId'];
    }



    if (this.model.filter['hasSignature'] === undefined) {
      delete params['hasSignature'];
    } else {
      params['hasSignature'] = this.model.filter['hasSignature'];
    }

    if (this.model.filter['person'] && this.model.filter['person'].identifier) {

      params['personId'] = this.model.filter['person'].identifier;

    } else {
      delete params['personId'];
    }

    if (this.model.filter['user'] && this.model.filter['user'].identifier) {

      params['identifier'] = this.model.filter['user'].identifier;

    } else {
      delete params['identifier'];
    }

    // params['expand'] = 'expansionSet:manage';

    params['expand'] = 'expansionSet:collection';




    return params;
  }

  public preEditRowFunction(model: any) {
    let params: any = {};
    params.retrievAllProfilesApplicationData = true;



    if (model._parent.ui?.allProfiles) {
      if (model.profiles && model.profiles.length > 0) {
        model.profiles.map((element) => {
          // ip.profile.description = profile.description + ' - ' + profile.application;
          element.uuid = element.identifier;
          element.identifier = element.identifier + '<>' + element.application;
        });

      }

      if (model.queries && model.queries.length > 0) {
        model.queries.map((element) => {
          // ip.profile.description = profile.description + ' - ' + profile.application;
          element.uuid = element.identifier;
          element.identifier = element.identifier + '<>' + element.application;
        });

      }
      return of(model);
    } else {


      return forkJoin([

        this.plycaService.query<any>(
          this.configuration.PROFILES_SERVICE_URL + '', params)
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          })),

        this.plycaService
          .getResultSearchSetting(this.configuration.URL_BASE + this.configuration.UserApiUrl + this.configuration.ApiVersion + 'searchsettings/TIPO_QUERY' + '/values',
            undefined
          ).pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))


      ]).pipe(
        map(

          ([resultProfiles, resultQueries]) => {
            if (resultProfiles) {
              model._parent.ui.allProfiles = {};
              if (resultProfiles && resultProfiles.content) {
                model._parent.ui.allProfiles = resultProfiles.content;
                model._parent.ui.allProfiles.map((profile) => {
                  profile.description = profile.description + ' - ' + profile.application;
                  profile.identifier = profile.identifier + '<>' + profile.application;
                })

              } else {
                model._parent.ui.allProfiles = [];

              }


            }
            if (resultQueries?.content) {
              model._parent.ui.allQueries = {};
              if (resultQueries && resultQueries.content) {
                model._parent.ui.allQueries = resultQueries.content;
                model._parent.ui.allQueries.map((element) => {
                  // element = element.singleValue;
                  element.identifier = element.singleValue.identifier;
                  element.description = element.singleValue.description;
                  delete element['columns'];
                  delete element['singleValue'];
                })

              } else {
                model._parent.ui.allQueries = [];

              }
            }
            if (model.profiles && model.profiles.length > 0) {
              model.profiles.map((element) => {
                // ip.profile.description = profile.description + ' - ' + profile.application;
                element.uuid = element.identifier;
                element.identifier = element.identifier + '<>' + element.application;
              });

            }

            if (model.queries && model.queries.length > 0) {
              model.queries.map((element) => {
                // ip.profile.description = profile.description + ' - ' + profile.application;
                element.uuid = element.identifier;
                element.identifier = element.identifier + '<>' + element.application;
              });

            }
            return model;
          }),
        finalize(() => {

        })
      )










    }

  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = false;


    formConfig.functions.push({
      identifier: 'preEditRowFunction',
      fn: this.preEditRowFunction
    });



    formConfig.functions.push({
      identifier: 'edit',
      fn: this.edit.bind(this)
    });
    formConfig.functions.push({
      identifier: 'show',
      fn: this.show.bind(this)
    });
    formConfig.functions.push({
      identifier: 'copy',
      fn: this.copy.bind(this)
    });
    formConfig.functions.push({
      identifier: 'cancel',
      fn: this.cancel.bind(this)
    });
    formConfig.functions.push({
      identifier: 'deleteUser',
      fn: this.deleteUser.bind(this)
    });

    formConfig.functions.push({
      identifier: 'updatePassword',
      fn: this.updatePassword.bind(this)
    });
    formConfig.functions.push({
      identifier: 'userTasks',
      fn: this.userTasks.bind(this)
    });
    formConfig.functions.push({
      identifier: 'userHistory',
      fn: this.userHistory.bind(this)
    });

    formConfig.functions.push({
      identifier: 'searchFunction',
      fn: this.searchFunction.bind(this)
    });



    return of(formConfig);
  }



  public cancel(model: any) {
    this.uiService.showSuccess(
      this.translate.instant('General.msg.cancel'),
      this.translate.instant('General.info'),
      'warn'
    );

  }

  /*
            {
              "functionName": "deleteUser",
              "buttonTextKey": "General.delete",
              "imageClass": "fas fa-times",
              "active": "true"
            }
  */
  public deleteUser(model: any) {
    this.confirmationService.confirm({
      message: this.translationService.instant('General.confirm.action.delete'),
      accept: () => {
        this.uiService.showSuccess(
          'Operación no implementada',
          this.translate.instant('General.info'),
          'warn'
        );
        /*
       this.waitService.startWaiting();

       this.subscribe(
         this.cleanHistory(this.model.dto.identifier), () => {
           this.waitService.cancelWaiting();
           this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
             'success');

         },
         (error: any) => {
           this.waitService.cancelWaiting();
           this.uiService.showSuccess(this.translate.instant('General.errorMessage'), this.translate.instant('General.info'),
             'error');
           this.plycaErrorHandler.showServerError(error);

         });
         */
      }
    });
  }
  show(model: any) {
    this.modalOpen(model, 'show');
  }
  copy(model: any) {
    this.modalOpen(model, 'copy');
  }
  edit(model: any) {
    let operation = model.identifier ? 'update' : 'insert';
    this.modalOpen(model, operation);
  }
  modalOpen(model: any, operation: string) {
    let css = 'formEdition';
    let title = 'ControlPanel.users.actions.edit';
    if (operation === 'insert' || operation === 'copy') {
      title = 'ControlPanel.users.actions.new';
    }
    if (operation === 'show') {
      title = 'ControlPanel.users.actions.show';
      css = 'viewStyle';
    }

    let config: DynamicDialogConfig = {
      header: this.translate.instant(title),
      width: '90%',
      styleClass: css

    };

    config['id'] = model.identifier;
    config['operation'] = operation;
    // config['readonly'] = readonly
    this.waitService.startWaiting();
    const dialog = this.dialogService.open(UserEditionComponent, config);
    dialog.onClose.subscribe(newInvoice => {
      this.search();


    });

  }

  modalError(error) {
    // this.ref.close();
    this.plycaErrorHandler.showServerError(error);
    // this.uiService.showMessage(
    //   error.errors[0].message,
    //   this.translateService.instant('General.error'),
    //   'errorStyle'
    // );
  }



  public updatePassword(rowData: any) {


    let config: DynamicDialogConfig = {
      header: this.translateService.instant('UserPrefs.password.change'),
      width: '40%',
      styleClass: 'actionStyle',
      style: { overflow: 'hidden' }
    };
    config['user'] = rowData;
    return this.dialogService.open(ChangePasswordComponent, config);

  }

  private cleanHistory(usuid: string): Observable<any> {
    // TODO revisar plycaService simpleUpdate
    this.waitService.startWaiting();
    let url = this.configuration.URL_BASE + this.configuration.ADMIN_USER_SERVICE_URL + 'cleanHistory?user=' + usuid;
    return this._http.put(url, {}, { observe: 'response' }).pipe(
      catchError((error: any) => {

        return throwError(error);

      }),
      finalize(() => this.waitService.cancelWaiting())
    );


  }


  private userTasks(user: UserDTO) {

    let title = 'ControlPanel.users.actions.userTasks';
    let config: DynamicDialogConfig = {
      header: this.translate.instant(title) + ' [' + user.identifier + ']',
      width: '60%',
      styleClass: 'viewStyle'

    };

    let params: { [param: string]: any } = {};
    params['page'] = 0;
    params['size'] = 9999;
    params['expand'] = 'expansionSet:client_tasks';

    params['userName'] = user.identifier;
    /* this.isModalWindow = true;
     this.windowHash = generateRandomIdentifier();
     this.waitService.startWaiting();*/
    let t;
    this.waitService.startWaiting();
    this.subscribe(
      this.plycaService.query(
        this._configuration.TAKS_SERVICE_URL, params
      ).pipe(
        tap((param: PaginationDTO<TaskDTO>) => {
          t = param ? param.content : [];
          config['usuid'] = user.identifier;
          config['list'] = t;

          const dialog = this.dialogService.open(tasksListComponent, config);
          dialog.onClose.subscribe(person => {



          });

        }),
        catchError(
          (err) => {

            this.plycaErrorHandler.showServerError(err);
            this.waitService.cancelWaiting();

            return of(true);
          }),
        finalize(() => {

        })
      )
    );



  }






  private userHistory(user: UserDTO) {




    this.confirmationService.confirm({
      message: this.translationService.instant('ControlPanel.users.confirm.cleanHistory'),
      accept: () => {
        this.waitService.startWaiting();
        this.subscribe(
          this.cleanHistory(user.identifier), () => {
            this.waitService.cancelWaiting();
            this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
              'success');

          },
          (error: any) => {
            this.waitService.cancelWaiting();
            this.uiService.showSuccess(this.translate.instant('General.errorMessage'), this.translate.instant('General.info'),
              'error');
            this.plycaErrorHandler.showServerError(error);

          });
      }
    });





  }



}



/*



this.subscribe(this.headerActionsService
  .addWindowAction('ControlPanel.substitutions.title', 'fas fa-people-carry', 'btn-secondary',
    true, this.windowHash),

  (success) => {
    // this.noImplemented();

    this.router.navigate(['/substitutions/'], { queryParams: { userid: this.model.dto.identifier, } });
    this.ref.close();

  });

this.subscribe(this.headerActionsService
  .addWindowAction('ControlPanel.inboxs.title', 'fas fa-inbox', 'btn-secondary',
    true, this.windowHash),

  (success) => {
    this.router.navigate(['/inbox/'], { queryParams: { userid: this.model.dto.identifier, } });
    this.ref.close();
  });

*/
